var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamsupdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-users-round w-5 h-5 flex-shrink-0",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 21a8 8 0 0 0-16 0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8,
    r: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsupdate);
export default __webpack_public_path__ + "static/media/teamsupdate.5e1697be756a03fc1559e9828f055e4c.svg";
export { ForwardRef as ReactComponent };